<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['barData', 'barLabels', 'yStepSize', 'yMax', 'datasetLabel'],
  mounted () {
    this.render()
  },
  watch: {
    barData () {
      this.render()
    },
    barLabels () {
      this.render()
    }
  },
  methods: {
    render () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderChart({
        labels: this.barLabels,
        datasets: [
          {
            label: this.datasetLabel,
            backgroundColor: '#20a8d8',
            data: this.barData
          }
        ]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: this.yStepSize,
              max: this.yMax,
              precision: 0
            }
          }]
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/reports/BarChart.vue